import { Box, Divider, Grid } from '@mui/material'
import CustomText from 'components/common/CustomText/CustomText'
import { useFormContext } from 'react-hook-form'
import { colors } from 'styles/colors'
import { caseSharedProps, registryProcedureDataType } from 'types/types'
import useGlobalStyles from 'styles/globalStyles'
import { memo, useCallback, useEffect, useMemo, useState } from 'react'
import PositionDialog from 'components/user/PositionDialog/PositionDialog'
import { ProfileProvider } from 'context/ProfileContext'
import { getRegistryPatientInformationFields } from 'common/utils'
import { useRegistryContext } from 'context/RegistryContext'
import { ECustomFieldType } from 'enum/ECustomFieldType'
import CustomField from 'components/inputs/CustomField/CustomField'

interface Props {
  shared: caseSharedProps;
}

function RegistryPatientInformation({
  shared,
}: Props) {
  const globalStyles = useGlobalStyles();
  const [open, setOpen] = useState<boolean>(false);
  const { registry } = useRegistryContext();

  const {
    genders,
    userHospitals,
    refetchHospitals,
    roles,
  } = shared;

  const {
    register,
    control,
    formState: { errors },
  } = useFormContext<registryProcedureDataType>()

  const hospitalsWithAction = useMemo(() => [
    ...(userHospitals || []),
    { value: '__add_hospital__', label: 'Add Institution' },
  ], [userHospitals]);

  const getFieldOptions = (fieldName: string) => {
    switch (fieldName) {
      case 'gender':
        return genders;
      case 'institute':
        return hospitalsWithAction;
      case 'role':
        return roles;
      default:
        return [];
    }
  }

  const fields = useMemo(() => {
    const basicFields = registry ? getRegistryPatientInformationFields(registry.fields) : [];
    basicFields.forEach(field => {
      if (field.type == ECustomFieldType.DROPDOWN_LIST) {
        field.options = getFieldOptions(field.name);
      }
    });
    return basicFields;
  }, [registry, genders, hospitalsWithAction]);
  

  const renderFields = useCallback(() => {

    return (
      <>
        {fields.map(field => {
          return <CustomField key={field.name} field={field} />
        })}
      </>
    )
  }, [fields, genders, hospitalsWithAction]);

  return (
    <ProfileProvider>
      <Box
        className={globalStyles.sectionContainer}
      >
        <Box className={globalStyles.sectionHeader}>
          <CustomText
            text="Patient Information"
            color={colors.primary}
            fontWeight={600}
          />
        </Box>

        <Divider />

        <Grid container p={3} spacing={1.5}>

          {renderFields()}

        </Grid>

      </Box>


      <PositionDialog
        open={open}
        setOpen={setOpen}
        entity={'position'}
        refetchHospitals={refetchHospitals}
      />
    </ProfileProvider>
  )
}

export default memo(RegistryPatientInformation);
